"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRequiredTrustedDeviceTexts = exports.getBlockedTexts = exports.getModalTexts = exports.getFailedTexts = exports.getFourEyesTexts = exports.getBiocheckTexts = exports.getIvrTexts = exports.getSignatureKeyTexts = exports.getTrustedTexts = exports.getOTPTexts = void 0;
const translatedComponents_1 = require("../../authoriser/components/translatedComponents");
const translations_1 = require("../../translations");
const features_1 = require("../../features");
const types_1 = require("../../authoriser/types");
const types_2 = require("../types");
const getOTPTexts = (componentConfig) => ({
    [types_1.OtpChallengeChannel.EMAIL]: {
        title: (0, translations_1.translate)(features_1.AuthoriserLiterals.EMAIL_TITLE),
        description: (0, translations_1.translate)(features_1.AuthoriserLiterals.EMAIL_DESCRIPTION),
        changeText: (0, translations_1.translate)(features_1.AuthoriserLiterals.MODIFY_EMAIL_LINK),
        label: (0, translations_1.translate)(features_1.AuthoriserLiterals.EMAIL_CODE_LABEL),
        placeholder: (0, translations_1.translate)(features_1.AuthoriserLiterals.EMAIL_PLACEHOLDER),
        helpText: componentConfig && (0, translatedComponents_1.buildHelpOtpComponent)(types_1.OtpChallengeChannel.EMAIL, componentConfig.helpOtp),
        errorTitle: (0, translations_1.translate)(features_1.AuthoriserLiterals.WARNING_INFO_TITLE),
        errorDescription: (0, translations_1.translate)(features_1.AuthoriserLiterals.WARNING_INFO_DESCRIPTION),
        errorButton: (0, translations_1.translate)(features_1.AuthoriserLiterals.RETRY_BUTTON),
        validateText: (0, translations_1.translate)(features_1.AuthoriserLiterals.VALIDATE_BUTTON),
        notification: {
            [types_2.SnackbarMessageType.SUCCESS]: {
                title: (0, translations_1.translate)(features_1.AuthoriserLiterals.SNACKBAR_EMAIL_SUCCESS),
            },
            [types_2.SnackbarMessageType.ERROR]: {
                title: (0, translations_1.translate)(features_1.AuthoriserLiterals.SNACKBAR_EMAIL_ERROR),
            },
        },
        skeletonText: (0, translations_1.translate)(features_1.AuthoriserLiterals.LOADING_STKELETON),
    },
    [types_1.OtpChallengeChannel.SMS]: {
        title: (0, translations_1.translate)(features_1.AuthoriserLiterals.SMS_TITLE),
        description: (0, translations_1.translate)(features_1.AuthoriserLiterals.SMS_DESCRIPTION),
        changeText: (0, translations_1.translate)(features_1.AuthoriserLiterals.MODIFY_MOBILE_LINK),
        label: (0, translations_1.translate)(features_1.AuthoriserLiterals.SMS_CODE_LABEL),
        placeholder: (0, translations_1.translate)(features_1.AuthoriserLiterals.SMS_CODE_PLACEHOLDER),
        helpText: componentConfig && (0, translatedComponents_1.buildHelpOtpComponent)(types_1.OtpChallengeChannel.SMS, componentConfig.helpOtp),
        errorTitle: (0, translations_1.translate)(features_1.AuthoriserLiterals.WARNING_INFO_TITLE),
        errorDescription: (0, translations_1.translate)(features_1.AuthoriserLiterals.WARNING_INFO_DESCRIPTION),
        validateText: (0, translations_1.translate)(features_1.AuthoriserLiterals.VALIDATE_BUTTON),
        errorButton: (0, translations_1.translate)(features_1.AuthoriserLiterals.RETRY_BUTTON),
        notification: {
            [types_2.SnackbarMessageType.SUCCESS]: {
                title: (0, translations_1.translate)(features_1.AuthoriserLiterals.SNACKBAR_SMS_SUCCESS),
            },
            [types_2.SnackbarMessageType.ERROR]: {
                title: (0, translations_1.translate)(features_1.AuthoriserLiterals.SNACKBAR_SMS_ERROR),
            },
        },
        skeletonText: (0, translations_1.translate)(features_1.AuthoriserLiterals.LOADING_STKELETON),
    },
    [types_1.OtpChallengeChannel.PUSH]: {
        title: (0, translations_1.translate)(features_1.AuthoriserLiterals.OTP_PUSH_TITLE),
        description: (0, translations_1.translate)(features_1.AuthoriserLiterals.OTP_PUSH_DESCRIPTION),
        changeText: (0, translations_1.translate)(features_1.AuthoriserLiterals.MODIFY_MOBILE_LINK),
        label: (0, translations_1.translate)(features_1.AuthoriserLiterals.OTP_PUSH_CODE_LABEL),
        placeholder: (0, translations_1.translate)(features_1.AuthoriserLiterals.OTP_PUSH_PLACEHOLDER),
        helpText: componentConfig && (0, translatedComponents_1.buildHelpOtpComponent)(types_1.OtpChallengeChannel.PUSH, componentConfig.helpOtp),
        errorTitle: (0, translations_1.translate)(features_1.AuthoriserLiterals.WARNING_INFO_TITLE),
        validateText: (0, translations_1.translate)(features_1.AuthoriserLiterals.VALIDATE_BUTTON),
        errorDescription: (0, translations_1.translate)(features_1.AuthoriserLiterals.WARNING_INFO_DESCRIPTION),
        errorButton: (0, translations_1.translate)(features_1.AuthoriserLiterals.RETRY_BUTTON),
        informativeTitle: (0, translations_1.translate)(features_1.AuthoriserLiterals.OTP_PUSH_INFORMATIVE_TITLE),
        informativeDescription: (0, translations_1.translate)(features_1.AuthoriserLiterals.OTP_PUSH_INFORMATIVE_DESCRIPTION),
        notification: {
            [types_2.SnackbarMessageType.SUCCESS]: {
                title: (0, translations_1.translate)(features_1.AuthoriserLiterals.SNACKBAR_PUSH_SUCCESS),
            },
            [types_2.SnackbarMessageType.ERROR]: {
                title: (0, translations_1.translate)(features_1.AuthoriserLiterals.SNACKBAR_PUSH_ERROR),
            },
        },
        skeletonText: (0, translations_1.translate)(features_1.AuthoriserLiterals.LOADING_STKELETON),
    },
});
exports.getOTPTexts = getOTPTexts;
const getTrustedTexts = (componentConfig) => ({
    main: {
        [types_2.OtpTrustedChallengeStateType.DEFAULT]: {
            title: (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_DEFAULT_TITLE),
            description: (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_DEFAULT_DESCRIPTION),
            timeText: (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_DEFAULT_TIME_TEXT),
            helpText: ' ',
            linkText: (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_DEFAULT_LINK_TEXT),
            secondaryText: (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_DEFAULT_SECONDARY_TEXT),
            linkSecondaryText: (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_DEFAULT_LINK_SECONDARY_TEXT),
            altImage: 'default-trusted-device-image',
            titleImage: 'default-trusted-device-image',
        },
        [types_2.OtpTrustedChallengeStateType.ERROR]: {
            title: (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_ERROR_TITLE),
            description: (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_ERROR_DESCRIPTION),
            timeText: (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_ERROR_TIME_TEXT),
            helpText: (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_ERROR_HELP_TEXT),
            linkText: (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_ERROR_LINK_TEXT),
            altImage: 'error-trusted-device-image',
            titleImage: 'error-trusted-device-image',
        },
        [types_2.OtpTrustedChallengeStateType.SUCCESS]: {
            title: (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_SUCCESS_TITLE),
            description: (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_SUCCESS_DESCRIPTION),
            altImage: 'success-trusted-device-image',
            titleImage: 'success-trusted-device-image',
        },
        [types_2.OtpTrustedChallengeStateType.WARNING]: {
            title: 'You need a trusted device!',
            description: 'In order to log in your Globan position, you will need a trusted device. You can donwload/open your app [Bank Name].',
            imgURL: [
                {
                    altImage: 'warning-trusted-device-image',
                    titleImage: 'warning-trusted-device-image',
                },
                {
                    altImage: 'warning-trusted-device-image',
                    titleImage: 'warning-trusted-device-image',
                },
            ],
        },
    },
    snackbar: {
        [types_2.SnackbarMessageType.ERROR]: {
            title: (0, translations_1.translate)(features_1.AuthoriserLiterals.SNACKBAR_TRUSTED_ERROR),
            closeIconAlt: (0, translations_1.translate)(features_1.AuthoriserLiterals.SNACKBAR_CLOSE_ICON),
        },
        [types_2.SnackbarMessageType.SUCCESS]: {
            title: (0, translations_1.translate)(features_1.AuthoriserLiterals.SNACKBAR_TRUSTED_SUCCESS),
            closeIconAlt: (0, translations_1.translate)(features_1.AuthoriserLiterals.SNACKBAR_CLOSE_ICON),
        },
    },
    message: {
        [types_2.TrustedMessageType.INFORMATION]: {
            title: (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_MESSAGE_INFORMATION_TITLE),
            description: (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_MESSAGE_INFORMATION_DESCRIPTION),
            button: (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_MESSAGE_INFORMATION_BUTTON),
        },
        [types_2.TrustedMessageType.ERROR]: {
            title: (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_MESSAGE_ERROR_TITLE),
            description: (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_MESSAGE_ERROR_DESCRIPTION),
            button: (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_MESSAGE_ERROR_BUTTON),
        },
        [types_2.TrustedMessageType.SECOND_ERROR]: {
            title: (0, translations_1.translate)(features_1.AuthoriserLiterals.TRUSTED_MESSAGE_ERROR_TITLE),
            description: componentConfig && (0, translatedComponents_1.buildSecondaryInfoComponent)(componentConfig.secondaryInfo),
        },
    },
});
exports.getTrustedTexts = getTrustedTexts;
const getSignatureKeyTexts = () => ({
    title: (0, translations_1.translate)('mbSignaturePattern.title'),
    getDescription: (initialPositions, lastPosition) => (0, translations_1.translate)('mbSignaturePattern.description', {
        initialPositions,
        lastPosition,
    }),
    titleInputDigitSequence: (0, translations_1.translate)('mbSignaturePattern.signatureKeyTextBox'),
    verifyButton: (0, translations_1.translate)('mbSignaturePattern.sendSignatureKeyButton'),
    previousTextLink: (0, translations_1.translate)('mbSignaturePattern.helpDescription'),
    linkText: (0, translations_1.translate)('mbSignaturePattern.helpDescriptionLink'),
});
exports.getSignatureKeyTexts = getSignatureKeyTexts;
const getIvrTexts = () => ({
    title: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_IVR_TITLE),
    description: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_IVR_DESCRIPTION),
    button: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_IVR_BUTTON),
    informationTitle: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_IVR_INFORMATION_TITLE),
    informationDescription: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_IVR_INFORMATION_DESCRIPTION),
    userError: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_IVR_USER_ERROR),
    technicalError: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_IVR_TECHNICAL_ERROR),
    blocked: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_IVR_BLOCKED),
    success: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_IVR_SUCCESS),
});
exports.getIvrTexts = getIvrTexts;
const getBiocheckTexts = () => ({
    title: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_BIOCHECK_TITLE),
    description: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_BIOCHECK_DESCRIPTION),
    button: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_BIOCHECK_BUTTON),
    informationDescription: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_BIOCHECK_INFORMATION_DESCRIPTION),
    informationTitle: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_BIOCHECK_INFORMATION_TITLE),
    extraActionButtonContent: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_BIOCHECK_EXTRA_ACTION_BUTTON_CONTENT),
    informationTitleSuccess: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_BIOCHECK_INFORMATION_TITLE_SUCCESS),
    informationDescriptionSuccess: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_BIOCHECK_INFORMATION_DESCRIPTION_SUCCESS),
    secondDescription: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_BIOCHECK_SECOND_DESCRIPTION),
});
exports.getBiocheckTexts = getBiocheckTexts;
const getFourEyesTexts = () => ({
    title: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_FOUR_EYES_TITLE),
    description: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_FOUR_EYES_DESCRIPTION),
    button: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_FOUR_EYES_BUTTON),
    informationTitle: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_FOUR_EYES_INFORMATION_TITLE),
    informationTitleSuccess: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_FOUR_EYES_INFORMATION_TITLE_SUCCESS),
    informationDescription: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_FOUR_EYES_INFORMATION_DESCRIPTION),
    informationDescriptionSuccess: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_FOUR_EYES_INFORMATION_DESCRIPTION_SUCCESS),
    extraActionButtonContent: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_FOUR_EYES_EXTRA_ACTION_BUTTON_CONTENT),
    informationDescriptionUserError: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_FOUR_EYES_INFORMATION_DESCRIPTION_USER_ERROR),
    usernameLabel: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_FOUR_EYES_USERNAME_LABEL),
    passLabel: (0, translations_1.translate)(features_1.AuthoriserLiterals.CC_FOUR_EYES_PASS_LABEL),
});
exports.getFourEyesTexts = getFourEyesTexts;
const getFailedTexts = () => ({
    title: (0, translations_1.translate)(features_1.AuthoriserLiterals.FAILED_TITLE),
    description: (0, translations_1.translate)(features_1.AuthoriserLiterals.FAILED_DESCRIPTION),
    button: (0, translations_1.translate)(features_1.AuthoriserLiterals.FAILED_TRY_AGAIN_BUTTON),
});
exports.getFailedTexts = getFailedTexts;
const getModalTexts = () => ({
    closeIcon: (0, translations_1.translate)(features_1.AuthoriserLiterals.MODAL_CLOSE_ICON),
    title: (0, translations_1.translate)(features_1.AuthoriserLiterals.MODAL_TITLE),
    cancelLink: (0, translations_1.translate)(features_1.AuthoriserLiterals.MODAL_CANCEL_LINK),
    confirmButton: (0, translations_1.translate)(features_1.AuthoriserLiterals.MODAL_CONFIRM_BUTTON),
});
exports.getModalTexts = getModalTexts;
const getBlockedTexts = () => ({
    title: (0, translations_1.translate)(features_1.AuthoriserLiterals.BLOCKED_AUTHORISER_TITLE),
    description: (0, translations_1.translate)(features_1.AuthoriserLiterals.BLOCKED_AUTHORISER_DESCRIPTION),
});
exports.getBlockedTexts = getBlockedTexts;
const getRequiredTrustedDeviceTexts = () => ({
    title: (0, translations_1.translate)(features_1.AuthoriserLiterals.REQUIRED_TRUSTED_DEVICE_AUTHORISER_TITLE),
    description: (0, translations_1.translate)(features_1.AuthoriserLiterals.REQUIRED_TRUSTED_DEVICE_AUTHORISER_DESCRIPTION),
});
exports.getRequiredTrustedDeviceTexts = getRequiredTrustedDeviceTexts;
//# sourceMappingURL=authoriser.constants.js.map